<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-currency`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm-4.465 7.657l4.243 4.242 4.243-4.242a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-4.962 4.962H31a1 1 0 011 1v2a1 1 0 01-1 1h-5V28h5a1 1 0 011 1v2a1 1 0 01-1 1h-5v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-5a1 1 0 01-1-1v-2a1 1 0 011-1h5v-2.553h-5a1 1 0 01-1-1v-2a1 1 0 011-1h4.668l-.011-.012-4.95-4.95a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0z"/></svg>
</template>
<script>

export default {
  name: 'IconCurrency',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
